import React from "react";

const TextArea = ({ name, label, error, value, ...rest }) => {
  return (
    <div className="form-group">
      <label className="form-control-label" htmlFor={name}>
        {label}
      </label>
      <textarea
        {...rest}
        value={value ?? ""}
        id={name}
        name={name}
        className="form-control"
        placeholder={label}
      />
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default TextArea;
